
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/5293eba213fbe763e3b6fb9c801d9617.png" 
              alt="Yıldırım Reklam Logo" 
              className="h-12 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#anasayfa" className={`font-medium transition-colors hover:text-red-600 whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>
              Ana Sayfa
            </a>
            <a href="#hakkimizda" className={`font-medium transition-colors hover:text-red-600 whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>
              Hakkımızda
            </a>
            <a href="#hizmetler" className={`font-medium transition-colors hover:text-red-600 whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>
              Hizmetler
            </a>
            <a href="#iletisim" className={`font-medium transition-colors hover:text-red-600 whitespace-nowrap ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}>
              İletişim
            </a>
          </div>
          <a 
            href="tel:+908503073704" 
            className="hidden md:flex items-center space-x-2 bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill"></i>
            <span className="font-medium">+90 850 307 3704</span>
          </a>
        </div>
      </nav>

      {/* Sections */}
      <Hero />
      <About />
      <Services />
      <Contact />
      <Footer />
      
      {/* WhatsApp Button */}
      <WhatsAppButton />
    </div>
  );
}
